module.exports = __webpack_public_path__ + "static/media/bad.4e5817e8.svg";